export default [
  {
    path: "/wt-article-detail/:code",
    name: "ArticleDetail",
    meta: {
      title: "详情",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "article" */ "@/views/article/ArticleDetail.vue"
      )
  }
];
